import { FACILITY_USER_ACCESS_MODE } from '@/constants/facilityUserAccessModes';

export const ALL_FACILITIES_PERMISSION_TARGET_ID =
  FACILITY_USER_ACCESS_MODE.ALL_FACILITIES;

export const hasSelectedPermissions = (permissions) => {
  if (!permissions || typeof permissions !== 'object') {
    return false;
  }

  return Object.values(permissions).some((value) => {
    if (Array.isArray(value)) {
      return value.length > 0;
    }

    return hasSelectedPermissions(value);
  });
};

export const toPermissionPayload = (permissions) =>
  hasSelectedPermissions(permissions) ? permissions : null;
